import React, { useEffect, useState } from "react";
import { faCartShopping, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Cart.css";
import { Button } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import CartProductCard from "./cart_product_card/CartProductCard";
import Breadcrumb_comp from "../common_components/breadcrumb-comp/Breadcrumb_comp";
import Payment_Summary from "./payment_summary/Payment_Summary";
import Similar_Products from "../product_description/similar_products/Similar_Products";
import Cart_Similar_Products from "./cart_similar_products/Cart_Similar_Products";
import Special_Instructions_Modal from "../common_components/common_modal/Special_Instructions_Modal/Special_Instructions_Modal";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart } from "../../features/cart/cartSlice";
import { appSetup } from "../../features/master/masterSlice";
import { getAllProducts } from "../../features/products/productsSlice";

const Cart = ({ setDeliveryNote, deliveryNote, ...props }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [totalSaving, setTotalSaving] = useState();
  const [totaAmount, setTotalAmount] = useState();
  const [count, setCount] = useState();

  const cart = useSelector((state) => state.cart.allCarts);

  useEffect(() => {
    dispatch(getAllCart(props?.isSignIn));
  }, []);

  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(appSetup());
  }, []);

  const [modalShow, setModalShow] = useState(false);

  const parts = [
    props?.orderAddress?.building,
    props?.orderAddress?.street,
    props?.orderAddress?.apartment,
    props?.orderAddress?.Users_Address_Detail?.Country?.name,
    props?.orderAddress?.Users_Address_Detail?.State?.name,
    props?.orderAddress?.Users_Address_Detail?.City?.name,
    props?.orderAddress?.Users_Address_Detail?.Pincode?.name,
  ];

  // const saveTotal = () => {
  //   let totalMRP = 0;
  //   let totalSelling = 0;
  //   let count = 0;
  //   let total_addon = 0;
  //   if (cart?.data?.data?.length > 0) {
  //     for (const element of cart.data.data) {
  //       const price = Number(element?.Product_Variant?.price) || 0;
  //       const mrp = Number(element?.Product_Variant?.mrp) || 0;
  //       const qty = Number(element.quantity) || 1;

  //       let itemSelling = price * qty;
  //       let itemMRP = mrp * qty;

  //       // Add-ons: Multiple
  //       element.Cart_Addon_Multiples?.forEach((addon) => {
  //         const addonPrice = Number(addon.price) || 0;
  //         total_addon += addonPrice;
  //         // itemSelling += addonPrice * qty;
  //         // itemMRP += addonPrice * qty;
  //       });

  //       // Add-ons: Single (array)
  //       element.Cart_Addon_Singles?.forEach((addon) => {
  //         const addonPrice = Number(addon.price) || 0;
  //         total_addon += addonPrice;
  //         // itemSelling += addonPrice * qty;
  //         // itemMRP += addonPrice * qty;
  //       });

  //       totalSelling += itemSelling;
  //       totalMRP += itemMRP;
  //       count += 1;
  //     }
  //   }

  //   // Example: calculate tax 5% of selling price
  //   const tax = Number((totalSelling * 0.05).toFixed(2));

  //   const data = {
  //     total_mrp: totalMRP,
  //     total_tax: tax,
  //     no_of_item: count,
  //     total_selling_price: totalSelling,
  //     total_amount: totalSelling + tax,
  //     total_addon: total_addon,
  //   };

  //   return data;
  // };

  const saveTotal = (cart) => {
    let total = 0;
    let selling = 0;
    let count = 0;
    let tax = 0;
    let total_addon = 0;
    if (cart?.data?.data?.length > 0) {
      for (const element of cart?.data?.data) {
        const price = Number(element?.Product_Variant?.price);
        const mrp = Number(element?.Product_Variant?.mrp);
        const qty = Number(element.quantity);
        let addonprice = 0;
        element.Cart_Addon_Multiples?.forEach((addon) => {
          const addonPrice = Number(addon.price) || 0;
          addonprice += addonPrice * qty;
          // itemSelling += addonPrice * qty;
          // itemMRP += addonPrice * qty;
        });

        // Add-ons: Single (array)
        element.Cart_Addon_Singles?.forEach((addon) => {
          const addonPrice = Number(addon.price) || 0;
          addonprice += addonPrice * qty;
          // itemSelling += addonPrice * qty;
          // itemMRP += addonPrice * qty;
        });

        Object.values(element.selectedAddOns || {}).forEach((addonArray) => {
          addonArray.forEach((addon) => {
            const addonPrice = Number(addon.price) || 0;
            addonprice += addonPrice * qty;
          });
        });

        total += mrp * qty;
        tax +=
          ((price * qty + addonprice + Number(app_setup?.platform_percentage)) *
            element.Product.tax_percentage) /
          100;
        selling += price * qty;
        count += 1;
        total_addon += addonprice;
        setTotalAmount(total);
        setTotalSaving(selling);
        setCount(count);
      }
    }
    const data = {
      total_mrp: total,
      total_tax: tax,
      no_of_item: count,
      total_selling_price: selling,
      total_amount:
        selling + tax + total_addon + Number(app_setup?.platform_percentage),
      total_addon,
      total_platformCharge: app_setup?.platform_percentage,
    };
    return data;
  };
  const [data, setData] = useState();

  useEffect(() => {
    const data = saveTotal(cart);
    setData(data);
  }, [cart]);

  const allSimilarProducts = useSelector((state) => state.product.allProducts);
  useEffect(() => {
    if (cart?.data?.data?.length > 0) {
      dispatch(
        getAllProducts({
          category_id: cart?.data?.data[0]?.product?.p_category_id,
          // subcategory_id: cart?.data?.data[0]?.product?.p_sub_category_id,
          // childcategory_id: cart?.data?.data[0]?.product?.p_child_category_id,
        })
      );
    }
  }, [dispatch, cart]);

  const [canProceed, setCanProceed] = useState("");

  useEffect(() => {
    if (cart?.data?.data?.length > 0) {
      const hasUnavailable = cart?.data?.data.some((val) => {
        const stock = Number(val?.Product_Variant?.general_stock ?? 0);
        const quantity = Number(val?.quantity ?? 0);
        const isOutOfStock = stock < quantity;

        const isDeleted = val?.Product?.deletedAt !== null;

        return isOutOfStock || isDeleted; // If either condition is true
      });

      if (hasUnavailable) {
        setCanProceed(
          "Some products in your cart are unavailable . Please update your cart before proceeding to payment."
        );
      } else {
        setCanProceed(""); // No error message
      }
    }
  }, [cart]);

  return (
    <section className="Cart">
      <Breadcrumb_comp
        breadcrumbs={[
          { label: "Home", link: "/", isActive: false },
          { label: "cart", link: "", isActive: true },
        ]}
        additionalClass="groceries "
      />

      <div className="container ">
        <div className="cart_main_container">
          <div className="data_holder">
            {cart?.data?.data?.length > 0 ? (
              <div className="row">
                <div className="col-lg-8 col-md-12 col-sm-12 col-12">
                  <div className="left_side_card">
                    {cart.data.data.map((item, index) => {
                      const isDeleted = item?.Product?.deletedAt !== null;
                      const isOutOfStock =
                        (item?.Product_Variant?.general_stock ?? 0) <= 0;

                      return (
                        <div className="product_card_section" key={index}>
                          {/* Product Card */}
                          <CartProductCard
                            title={item?.Product?.name}
                            footer_text_color="#6EC090"
                            img={item?.Product?.image}
                            orderId="Order ID #675843"
                            items="2 Items"
                            kwd="Rs.: 200"
                            footer_text="Delivering in 10 mins"
                            date="27th Oct. | 03:28 pm"
                            customClass={""}
                            cartVarient={item}
                            saveTotal={saveTotal}
                          />

                          {/* Error for this specific product */}
                          {(isDeleted || isOutOfStock) && (
                            <div
                              style={{
                                color: "red",
                                fontWeight: "bold",
                                marginTop: "5px",
                                fontSize: "14px",
                                backgroundColor: "#ffe5e5",
                                padding: "5px",
                                borderRadius: "4px",
                              }}
                            >
                              ❌{" "}
                              {isDeleted
                                ? "This product is not available."
                                : "This product is out of stock."}
                            </div>
                          )}
                        </div>
                      );
                    })}

                    <div
                      className="delivery_note_div"
                      onClick={() => setModalShow(true)}
                    >
                      <div className="">
                        <p className="delivery_note">
                          Delivery Note (Optional)
                        </p>
                      </div>

                      <div className="">
                        <FontAwesomeIcon icon={faPlus} className="plus_icon" />
                      </div>
                    </div>
                    {allSimilarProducts?.length > 0 && (
                      <div className="cart_similar_prods">
                        <Cart_Similar_Products product={allSimilarProducts} />
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                  <Payment_Summary
                    canProceed={canProceed}
                    cart={cart}
                    app_setup={app_setup}
                    data={data}
                    parts={parts}
                  />
                </div>
              </div>
            ) : (
              <div
                className="empty_cart"
                style={{
                  textAlign: "center",
                  padding: "20px",
                  fontWeight: "bold",
                  fontSize: "40px",
                }}
              >
                🛒
                <p style={{ fontSize: "20px", margin: "10px 0 0" }}>
                  Your cart is empty
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <Special_Instructions_Modal
        deliveryNote={deliveryNote}
        setDeliveryNote={setDeliveryNote}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </section>
  );
};

export default Cart;
